import { useState } from 'react';

import { CheckIcon } from '@phosphor-icons/react';

import { PauseDurationDropdown } from './components/PauseDurationDropdown';

import { ButtonElement } from '../shared/buttonElement/ButtonElement';
import type { RetentionOptionElementProps } from './RetentionOptionElement.types';

export function RetentionOptionElement({
  title,
  message,
  buttonLabel,
  buttonType,
  isButtonDisabled,
  onClick,
  reasons,
  shouldUseThemeColors,
  pauseOptions,
}: RetentionOptionElementProps) {
  const hasPauseOption = Array.isArray(pauseOptions) && pauseOptions.length > 0;
  const [pauseDuration, setPauseDuration] = useState<string | undefined>(
    hasPauseOption ? pauseOptions[0].value : undefined,
  );

  const handleClick = () => {
    if (hasPauseOption) {
      onClick(pauseDuration);
    } else {
      onClick();
    }
  };

  return (
    <div className="flex flex-col min-w-[250px] border border-[#E5E7EB] rounded-md sm:min-w-[315px] overflow-hidden bg-white shadow-sm">
      <div
        className="flex flex-col gap-2 p-4 border-[#E5E7EB] border-b w-full h-[108px]"
        style={
          shouldUseThemeColors
            ? {
                background: 'var(--pt-background-color)',
                color: 'var(--pt-text-on-background-color)',
              }
            : undefined
        }
      >
        <h4
          className="text-gray-900 font-semibold text-base leading-6 w-full text-center"
          style={
            shouldUseThemeColors
              ? {
                  color: 'var(--pt-text-on-background-color)',
                }
              : undefined
          }
        >
          {title}
        </h4>
        {message && (
          <p
            className="text-gray-900 font-medium text-sm leading-5 w-full text-center"
            style={
              shouldUseThemeColors
                ? {
                    color: 'var(--pt-text-on-background-color)',
                  }
                : undefined
            }
          >
            {message}
          </p>
        )}
        {hasPauseOption && (
          <div className="w-full flex justify-center">
            <PauseDurationDropdown selectedValue={pauseDuration} options={pauseOptions} onChange={setPauseDuration} />
          </div>
        )}
      </div>
      <div className="flex flex-col justify-between gap-6 p-4" style={{ height: 'calc(100% - 108px)' }}>
        <ul className="space-y-2">
          {Array.isArray(reasons)
            ? reasons.map((reason) => (
                <li key={reason} className="flex items-start gap-2">
                  <CheckIcon className="w-5 h-5 text-gray-700 p-1" />
                  <p className="text-sm font-normal leading-5 text-gray-700">{reason}</p>
                </li>
              ))
            : null}
        </ul>
        <ButtonElement disabled={isButtonDisabled} type="button" variant={buttonType} onClick={handleClick}>
          {buttonLabel}
        </ButtonElement>
      </div>
    </div>
  );
}
